import { newToolFilterOAuthMcp } from "../oauth.ts";

export const couplerMcpResolver = newToolFilterOAuthMcp({
  iconUrl:
    "https://www.coupler.io/assets/favicon/favicon-light-69cfbdf9ddbacc7f9c612c8e9da604d4d06cf9f83215dee3f698f2b0b41dd150.svg",
  // Coupler.io also issues per-account URLs (`/mcp/<account-id>`); this shared
  // endpoint is the one its docs give for Claude Code.
  url: "https://mcp.coupler.io/mcp",
  label: "Coupler.io",
});
